var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": _vm.entitySummaries.length > 0,
          "show-delete":
            _vm.entitySummaries.length > 0 &&
            _vm.isReadOnly &&
            (this.$userInfo.isSupportUser ||
              this.$userInfo.isCustomerAdministrator),
          "show-cancel": _vm.showCancel,
          "show-save": !_vm.readOnlyView && _vm.entitySummaries.length > 0,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("dealer-credit-entry-side-menu", {
              attrs: {
                "vendor-detail": _vm.creditDetail,
                "is-read-only": _vm.isReadOnly,
              },
              on: {
                saved: function ($event) {
                  return _vm.updateSave($event)
                },
                filter: _vm.filterList,
                reset: _vm.resetList,
              },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-horizontal is-15" }, [
            _c("div", { staticClass: "tile is-parent" }, [
              _c(
                "article",
                { staticClass: "tile is-child box" },
                [
                  _c("dealer-credit-entry-detail-filter", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "is-entity": _vm.isEntity,
                    },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "tile is-parent" }, [
              _c(
                "article",
                { staticClass: "tile is-child box" },
                [
                  _c("dealer-credit-entry-detail-value", {
                    attrs: {
                      "credit-lines": _vm.entitySummaries,
                      "is-read-only": _vm.isReadOnly,
                      "is-entity": _vm.isEntity,
                    },
                    model: {
                      value: _vm.creditDetail,
                      callback: function ($$v) {
                        _vm.creditDetail = $$v
                      },
                      expression: "creditDetail",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c("dealer-credit-entry-detail", {
                  attrs: {
                    "vendor-detail": _vm.creditDetail,
                    "is-read-only": _vm.isReadOnly,
                    "is-entity": _vm.isEntity,
                  },
                  model: {
                    value: _vm.entitySummaries,
                    callback: function ($$v) {
                      _vm.entitySummaries = $$v
                    },
                    expression: "entitySummaries",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }